export const SYNC_CONNECTION_STATE = 'SYNC_CONNECTION_STATE';
export const SYNC_ADVICE_ROOM_CONNECTION_STATE = 'SYNC_ADVICE_ROOM_CONNECTION_STATE';
